import { Organization } from '../../types';

const CARTWHEEL_ORGANIZATION_ID = '5d7c64e2-632e-457e-8f94-d5578653e8ff';
const CARTWHEEL_TEST_APP_ORGANIZATION_ID =
    'bf82c885-cc8e-4e9f-b725-fe22de79bdbb';

export const isCartwheelOrganization = (organizations: Array<Organization>) => {
    const organizationId = organizations.at(0)?.id;

    if (!organizationId) {
        return false;
    }

    return [
        CARTWHEEL_ORGANIZATION_ID,
        CARTWHEEL_TEST_APP_ORGANIZATION_ID,
    ].includes(organizationId);
};
